import { PreviewFirstTransceiver } from 'src/features/preview-first-new-delivery-request/types';
import { atom, useAtom, useSetAtom } from 'jotai';

export const previewFirstSenderAtom = atom<PreviewFirstTransceiver | undefined>(undefined);
export const usePreviewFirstSenderAtom = () => {
  return useAtom(previewFirstSenderAtom);
};
export const usePreviewFirstSenderSetAtom = () => {
  return useSetAtom(previewFirstSenderAtom);
};
